module.exports = __webpack_public_path__ + "static/media/doctor.8f6c9146.svg";